export default __webpack_public_path__ + "static/media/logo-sm.39401baf.png";